module.exports = __webpack_public_path__ + "static/media/Logo-Tomatoma.7dcb0b63.png";